import { HStack, IconButton, Button, Text, useToken } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import hexToRgba from "hex-to-rgba";
import React from "react";

function Pagination({ totalCount, currentPage, pageSize, onPageChange, isDisabled }) {
  const [mainColor] = useToken("colors", ["primary.main"]);
  const pagesCount = Math.ceil(totalCount / pageSize);

  // Generate visible pages with ellipsis
  const getVisiblePages = () => {
    const pages = [];
    const maxVisiblePages = 5; // Show up to 5 pages (first, last, current, and one before/after)
    if (pagesCount <= maxVisiblePages) {
      for (let i = 1; i <= pagesCount; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1); // Always show first page
      if (currentPage > 3) {
        pages.push("..."); // Ellipsis before current page
      }
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(pagesCount - 1, currentPage + 1);
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      if (currentPage < pagesCount - 2) {
        pages.push("..."); // Ellipsis after current page
      }
      if (pagesCount > 1) {
        pages.push(pagesCount); // Always show last page
      }
    }
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <HStack justifyContent="end" mt={2} spacing={1}>
      <IconButton
        icon={<ChevronLeftIcon />}
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        isDisabled={isDisabled || currentPage === 1}
        bg={hexToRgba(mainColor, 0.4)}
        w={8}
        minH={8}
        fontSize="xs"
        aria-label="Previous page"
      />
      {visiblePages.map((page, index) =>
        page === "..." ? (
          <Text
            key={`ellipsis_${index}`}
            w={8}
            minH={8}
            fontSize="xs"
            display="flex"
            alignItems="center"
            justifyContent="center"
            color="gray.500"
          >
            ...
          </Text>
        ) : (
          <Button
            key={`pagination_page_${page}`}
            onClick={() => onPageChange(page)}
            bg={currentPage === page ? mainColor : hexToRgba(mainColor, 0.4)}
            color={currentPage === page ? "white" : "inherit"}
            w={8}
            minH={8}
            fontSize="xs"
            isDisabled={isDisabled}
            _hover={{ bg: mainColor, color: "white" }}
          >
            {page}
          </Button>
        )
      )}
      <IconButton
        icon={<ChevronRightIcon />}
        onClick={() => onPageChange(Math.min(currentPage + 1, pagesCount))}
        isDisabled={isDisabled || currentPage === pagesCount}
        bg={hexToRgba(mainColor, 0.4)}
        w={8}
        minH={8}
        fontSize="xs"
        aria-label="Next page"
      />
    </HStack>
  );
}

export default Pagination;